import PropTypes from 'prop-types';

/**
 * A single radio button input
 * 
 * @param {object} props
 * @param {string} props.id - radio button ID
 * @param {string} props.name - name of radio button group
 * @param {string} props.value - radio button value and label text
 */
const RadioInput = ({ id, name, value }) => {
    return (
        <div className='radio-input'>
            <input
                type="radio"
                id={id}
                name={name}
                value={value}
            />
            <label htmlFor={id}>{value}</label>
        </div>
    );
}

RadioInput.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

export default RadioInput;